import React from 'react';
import SEOLandingPage from '../SEOLandingPage';
import { Music, Headphones, Volume2, Sparkles } from 'lucide-react';

const ASMRVideoGeneratorPage: React.FC = () => {
  return (
    <SEOLandingPage 
      title="ASMR Video Generator"
      description="Create oddly satisfying ASMR ball simulation videos with perfectly synced audio. The ultimate tool for making hypnotic, relaxing physics animations for YouTube and TikTok."
      keywords="ASMR video generator, satisfying ASMR, ball ASMR, relaxing physics videos, oddly satisfying music, ASMR loops, fun circle games, funcirclegames, fun circle games creator studio"
      heroTitle="Oddly Satisfying ASMR Generator"
      heroSubtitle="Sync crystal-clear physics events with immersive spatial audio. Create hypnotic ASMR videos that keep viewers coming back for more."
      videoMeta={{
        name: "Hypnotic ASMR Ball Simulation",
        description: "Immerse yourself in rhythmic audio-visual bliss with our spatial sound physics engine.",
        thumbnailUrl: "https://funcirclegames.com/thumbnails/asmr-gen-hero.jpg",
        uploadDate: "2026-05-19T12:00:00Z",
        contentUrl: "https://funcirclegames.com/videos/asmr-gen-demo.mp4",
        embedUrl: "https://funcirclegames.com/embed/asmr-gen-demo"
      }}
      features={[
        {
          title: "Audio Sync Engine",
          description: "Every bounce and collision triggers a perfectly timed sound, creating rhythmically satisfying loops.",
          icon: <Music className="w-6 h-6" />
        },
        {
          title: "Spatial Sound",
          description: "Immersive audio that moves with the simulation, enhancing the the relaxing ASMR experience.",
          icon: <Headphones className="w-6 h-6" />
        },
        {
          title: "Custom Soundscapes",
          description: "Select from a library of high-fidelity sounds, from crystal chimes to deep bass impacts.",
          icon: <Volume2 className="w-6 h-6" />
        },
        {
          title: "Visual Pacing",
          description: "Adjust the speed and flow of your simulation to match the desired relaxation or intensity level.",
          icon: <Sparkles className="w-6 h-6" />
        }
      ]}
      contentSnippet="ASMR and 'oddly satisfying' content are pillars of modern social media consumption. Our ASMR video generator combines precise physics simulations with melodic audio synchronization, allowing you to create immersive digital experiences that resonate with millions of viewers. Whether it's for stress relief or entertainment, our tools help you craft the perfect therapeutic loop."
      currentTool="/asmr-video-generator"
    />
  );
};

export default ASMRVideoGeneratorPage;
